import axios from 'axios'

import axiosClient from './base'
// import  getConfigDetails  from './config'
import axiosClientWithoutAuth from './baseWithoutAuth'
// import { APICONFIG } from '../redux/apiConfig'

// Function to call Partner Details before every request
// async function preRequest() {
// const user = window.location.toString().split('/')[3]
//   try {
// 	// Check if the partner Details are already saved
// 	const partnerData = localStorage.getItem('partnerData') ? JSON.parse(localStorage.getItem('partnerData')) : {}
// 	if(partnerData?.id && partnerData?.email && ((partnerData?.slug != '' && partnerData?.slug != null && user == partnerData?.slug) || (partnerData?.partner_slug != '' && partnerData?.partner_slug != null && user == partnerData?.partner_slug))){
// 		return partnerData
// 	}else{
// 		// Else Call the API
//     if(user && user != 'mgooglepay' && !user.includes('mgooglepay')){
//       const response = await axios.get(`${APICONFIG?.getPartnerBySlug}/${user}`)
//       localStorage.setItem('partnerData', JSON.stringify(response?.data?.data))
//       return response.data // Or handle the response as needed
//     }
		
// 	}
	
//   } catch (error) {
//     console.error('Error in preRequest:', error)
//     throw new Error('Pre-request failed')
//   }
// }

// Higher-order function to wrap requests
// async function withPreRequest(requestFn) {
//   await preRequest()
//   return requestFn()
// }

export function getRequest(URL) {
  return axiosClient.get(URL)
}

export function postRequest(URL, payload) {
  return axiosClient.post(URL, payload)
}

export function getRequestWithoutAuth(URL) {
  return axiosClientWithoutAuth.get(URL)
}

export function postRequestWithoutAuth(URL, payload) {
  return axiosClientWithoutAuth.post(URL, payload)
}

export function patchRequest(URL, payload) {
  return axiosClient.patch(URL, payload)
}

export function deleteRequest(URL) {
  return axiosClient.delete(URL)
}

export function putRequest(URL, payload) {
  return axiosClient.put(URL, payload)
}


export function allRequest(allRequests) {
	return axios.all(allRequests).then(
		axios.spread(
			(...responses) => responses
			// use/access the results
		)
	)
}
export function downloadFile(path, fileName,setPromoLoader) {
	axios({
		url: path,
		method: 'GET',
		responseType: 'blob', // important
	}).then((response) => {
		const url = window.URL.createObjectURL(new Blob([response.data]))
		const link = document.createElement('a')
		link.href = url
		link.setAttribute('download', fileName)
		document.body.appendChild(link)
		link.click()
		// Clean up and remove the link
		link.parentNode.removeChild(link)
		setPromoLoader(false)
	}).catch(()=>{
		setPromoLoader(false)
	})
}